import React, { useEffect, useState } from 'react';
import Template from '../Components/Template';
import { useGetAllExamFormsQuery } from '../Services/modules/exam';
import { useGetAllAgentsQuery } from '../Services/modules/agents';
import { useNavigate } from 'react-router-dom';

function ReportDashboardAdmin() {
  const [totalForms, setTotalForms] = useState(0);
  const [totalRupees, setTotalRupees] = useState(0);
  const [totalAgents, setTotalAgents] = useState(0);

  const navigate = useNavigate();

  const {
    data: examData,
    isSuccess: isSuccessExam,
  } = useGetAllExamFormsQuery({ page_number: 0, page_size: 1 });

  const {
    data: agentData,
    isSuccess: isSuccessAgents,
  } = useGetAllAgentsQuery({ page_number: 0, page_size: 1 });

  useEffect(() => {
    if (isSuccessExam && examData) {
      setTotalForms(examData.totalRows || 0);
      setTotalRupees(examData.totalRupees || 0);
    }
  }, [examData]);

  useEffect(() => {
    if (isSuccessAgents && agentData) {
      setTotalAgents(agentData.total || 0);
    }
  }, [agentData]);

  return (
    <Template>
      <main id="main" className="main">
        <div className="container mt-4">
          {/* Summary Cards */}
         <div className="row text-center mb-5">
  <div className="col-md-4 mb-3">
    <div className="card bg-primary text-white shadow-sm h-100">
      <div className="card-body d-flex flex-column justify-content-center align-items-center">
        <h6 className="mb-2">Total Exam Forms</h6>
        <h3>{totalForms}</h3>
      </div>
    </div>
  </div>
  <div className="col-md-4 mb-3">
    <div className="card bg-success text-white shadow-sm h-100">
      <div className="card-body d-flex flex-column justify-content-center align-items-center">
        <h6 className="mb-2">Total Rupees Collected</h6>
        <h3>₹ {totalRupees}</h3>
      </div>
    </div>
  </div>
  <div className="col-md-4 mb-3">
    <div className="card bg-secondary text-white shadow-sm h-100">
      <div className="card-body d-flex flex-column justify-content-center align-items-center">
        <h6 className="mb-2">Total Agents</h6>
        <h3>{totalAgents}</h3>
      </div>
    </div>
  </div>
</div>

          {/* Action Cards */}
          <div className="row justify-content-center">
            <div className="col-md-3 mb-4">
              <div
                className="card bg-light border-0 shadow-sm h-100 text-center hover-shadow"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/reportsadmin')}
              >
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                  <h5 className="text-primary">📄 Export Forms</h5>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div
                className="card bg-light border-0 shadow-sm h-100 text-center hover-shadow"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/reportadminofagents')}
              >
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                  <h5 className="text-success">👥 Show All Agents</h5>
                </div>
              </div>
            </div>
             <div className="col-md-3 mb-4">
              <div
                className="card bg-light border-0 shadow-sm h-100 text-center hover-shadow"
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/reportAllExamFormsForAdminFilter')}
              >
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                  <h5 className="text-primary">📄 All forms with filters</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Template>
  );
}

export default ReportDashboardAdmin;
